import { GetProductMasterData } from "../store/productAtom";

function PlanMinimumFeeCurrency(props) {
  const masterData = GetProductMasterData();

  const handleChange = (val) => {
    props.onSelectMinimumCurrency(val.Code);
  };

  const createSelectItems = () => {
    let items = [];

    masterData[14]?.forEach((item, i) => {
      items.push(
        <option key={i} value={i}>
          {item.Name}
        </option>
      );
    });

    return items;
  };

  return (
    <>
      <select
        onChange={handleChange}
        className="h-[38px] rounded-l bg-gray-100 text-sm focus:outline-none focus:ring-0"
      >
        {createSelectItems()}
      </select>
    </>
  );
}

export default PlanMinimumFeeCurrency;
